var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDollarSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E90FF",
    fillRule: "evenodd",
    d: "M11 4.667v-2.75C11 1.41 11.448 1 12 1s1 .41 1 .917v2.75h4c.552 0 1 .41 1 .916 0 .507-.448.917-1 .917h-4v4.583h1.5c2.485 0 4.5 1.847 4.5 4.125s-2.015 4.125-4.5 4.125H13v2.75c0 .507-.448.917-1 .917s-1-.41-1-.917v-2.75H6c-.552 0-1-.41-1-.916 0-.507.448-.917 1-.917h5v-4.583H9.5c-2.485 0-4.5-1.847-4.5-4.125 0-2.279 2.015-4.125 4.5-4.125H11zM11 6.5H9.5C8.12 6.5 7 7.526 7 8.792c0 1.265 1.12 2.291 2.5 2.291H11V6.5zm2 6.417V17.5h1.5c1.38 0 2.5-1.026 2.5-2.292 0-1.265-1.12-2.291-2.5-2.291H13z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDollarSign);
export default __webpack_public_path__ + "static/media/Icon_Dollar_Sign.cd4b6eca09ef93416bf920d85bb8fccb.svg";
export { ForwardRef as ReactComponent };